// extracted by mini-css-extract-plugin
module.exports = {"thead":"styles_thead__2xaVR","label":"styles_label__1QKC5","filter":"styles_filter__2S0DP"};